import { storyblokEditable } from '@storyblok/react';
import { FC } from 'react';

import BG from '@/assets/cta-background.jpg';
import Container from '@/components/elements/Container';
import Section from '@/components/elements/Section';
import StandardText, {
  StandardTextSize,
} from '@/components/elements/StandardText';

export interface CallToActionProps {
  blok: any;
  cta?: object;
}

const CallToAction: FC<CallToActionProps> = ({
  blok,
  cta = blok.call_to_action,
}) => {
  return (
    <Section
      gapTop="lg"
      {...storyblokEditable(blok)}
      className="dark relative py-8 last:!mb-0 md:h-[34rem]"
    >
      <div
        className="absolute top-0 z-0 size-full"
        style={{
          background: `url(${BG.src})`,
          backgroundSize: 'cover',
          backgroundPosition: 'bottom center',
        }}
      ></div>
      <Container size="widest" className="relative z-20 h-full">
        <div className="grid h-full overflow-hidden">
          <div className={`flex h-full items-center`}>
            <div className={`w-full max-w-3xl py-16`}>
              <StandardText blok={cta.content} size={StandardTextSize.MD} />
            </div>
          </div>
        </div>
      </Container>
    </Section>
  );
};

export default CallToAction;
